export default "__VITE_ASSET__Bm274YDH__"